import axios from "axios";
import { useApi } from "../hooks/useApi";
import { exchangeElementsOfRes } from "../../pages/myExchangeElements/MyExchangeElements";

const api = useApi();

export async function canIcreateTrocAsRes(): Promise<boolean> {
  try {
    const response = await api.post("trocs-resident/can-i-do-troc");

    return (response.data.canIcreateTroc ? true : false);
  }
  catch (error) {
    throw error
  }
}

export async function getResidentsTrocsList(dataR: { region: string | null }) {
  try {

    const response = await api.post(`trocs-resident/troc-list-residents-all`, dataR);    
    return response;

  } catch (error) {
    if (axios.isAxiosError(error)) {
      if (error.response) {
        switch (error.response?.status) {
          case 400:
            throw new Error(`${error.response.data.message}`);
          case 500:
            throw new Error(`${error.response.data.message}`);
          default:
            throw new Error(`Une erreur est survenue.`);
        }
      }
      else if (error.request) {
        throw new Error(`Une erreur est survenue.`);
      }
      else if (axios.isCancel(error)) {
        throw new Error(`Une erreur est survenue.`);
      }
      else {
        // Ici on cast `error` comme un objet contenant un message
        throw new Error(`Une erreur est survenue.`);
      }
    }
    else {
      // Gère les erreurs non Axios (par exemple, erreur JavaScript générique)
      throw new Error(`Une erreur est survenue.`);
    }
  }
}

export async function getExchangeElementOfRes(resTrocId: number) {
  try {
    const response = await api.get(`trocs-resident/troc-id/${resTrocId}`);
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      if (error.response) {
        switch (error.response?.status) {
          case 400:
            throw new Error(`${error.response.data.message}`);
          case 500:
            throw new Error(`${error.response.data.message}`);
          default:
            throw new Error(`Une erreur est survenue.`);
        }
      }
      else if (error.request) {
        throw new Error(`Une erreur est survenue.`);
      }
      else if (axios.isCancel(error)) {
        throw new Error(`Une erreur est survenue.`);
      }
      else {
        // Ici on cast `error` comme un objet contenant un message
        throw new Error(`Une erreur est survenue.`);
      }
    }
    else {
      // Gère les erreurs non Axios (par exemple, erreur JavaScript générique)
      throw new Error(`Une erreur est survenue.`);
    }
  }
}

export async function getExchangeElementsOfRes(): Promise<exchangeElementsOfRes[]> {
  try {
    const response = await api.get('trocs-resident/troc-list-one-resident');
    return response.data.trocList;
  } catch (error) {
    throw error;
  }
}

export async function createTrocR(resTroc: {}): Promise<{ canIcreateTroc: boolean }> {
  try {
    const response = await api.post("trocs-resident/creating", resTroc);

    return response.data;
  }
  catch (error) {
    if (axios.isAxiosError(error)) {
      if (error.response) {
        switch (error.response?.status) {
          case 400:
            throw new Error(`${error.response.data.message}`);
          case 500:
            throw new Error(`${error.response.data.message}`);
          default:
            throw new Error(`Une erreur est survenue.`);
        }
      }
      else if (error.request) {
        throw new Error(`Une erreur est survenue.`);
      }
      else if (axios.isCancel(error)) {
        throw new Error(`Une erreur est survenue.`);
      }
      else {
        // Ici on cast `error` comme un objet contenant un message
        throw new Error(`Une erreur est survenue.`);
      }
    }
    else {
      // Gère les erreurs non Axios (par exemple, erreur JavaScript générique)
      throw new Error(`Une erreur est survenue.`);
    }
  }
}

export async function editTrocOfRes(
  trocId: number,
  dataTroc: {
    title: string;
    services: string[];
    needs: string[];
    flexible: boolean;
    start_time: string;
    end_time: string;
    description: string;
    departement?: string | null;
  }
): Promise<number> {
  try {
    const { status } = await api.put(`trocs-resident/editing-troc${trocId}`, dataTroc);

    return status;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      if (error.response) {
        switch (error.response?.status) {
          case 400:
            throw new Error(`${error.response.data.message}`);
          case 500:
            throw new Error(`${error.response.data.message}`);
          default:
            throw new Error(`Une erreur est survenue.`);
        }
      }
      else if (error.request) {
        throw new Error(`Une erreur est survenue.`);
      }
      else if (axios.isCancel(error)) {
        throw new Error(`Une erreur est survenue.`);
      }
      else {
        // Ici on cast `error` comme un objet contenant un message
        throw new Error(`Une erreur est survenue.`);
      }
    }
    else {
      // Gère les erreurs non Axios (par exemple, erreur JavaScript générique)
      throw new Error(`Une erreur est survenue.`);
    }
  }
}

export async function removeTrocOfRes(trocId: number): Promise<number> {
  try {
    const { status } = await api.delete(`trocs-resident/deleting-troc${trocId}`);
    return status;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      if (error.response) {
        switch (error.response?.status) {
          case 400:
            throw new Error(`${error.response.data.message}`);
          case 500:
            throw new Error(`${error.response.data.message}`);
          default:
            throw new Error(`Une erreur est survenue.`);
        }
      }
      else if (error.request) {
        throw new Error(`Une erreur est survenue.`);
      }
      else if (axios.isCancel(error)) {
        throw new Error(`Une erreur est survenue.`);
      }
      else {
        // Ici on cast `error` comme un objet contenant un message
        throw new Error(`Une erreur est survenue.`);
      }
    }
    else {
      // Gère les erreurs non Axios (par exemple, erreur JavaScript générique)
      throw new Error(`Une erreur est survenue.`);
    }
  }
}